import styled from 'styled-components/macro';
import { Icon } from 'antd';

// eslint-disable-next-line import/prefer-default-export
export const PresenterButtonIcon = styled(Icon)`
  font-size: 1rem;
  color: ${({ color }) => color ?? 'inherit'};
`;
